import React, {useCallback, useState} from 'react';
import {Box, ButtonBase} from '@mui/material';
import {Link} from "react-router-dom";
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const commonButtonStyles = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    borderRadius: 1,
    py: '6px',
    textAlign: 'left',
    width: '100%',
    '&:hover': {
        backgroundColor: '#4890fd'
    }
};

const commonBoxStyles = {
    color: 'white',
    fontFamily: 'Lexend Deca',
    flexGrow: 1,
    fontSize: 12,
    fontWeight: 600,
    lineHeight: '24px',
    ml: 1.2,
    mr: 1.6,
};

const commonIconStyles = {
    color: 'white',
    fontFamily: 'Lexend Deca',
    ml: 1
};

export const SideNavItem = (props) => {
    const {
        active = false,
        icon,
        path,
        title,
        beta,
        premium,
        subItems = [],
    } = props;
    const [isExpanded, setIsExpanded] = useState(false);

    const toggleExpand = useCallback(() => {
        setIsExpanded(prev => !prev);
    }, []);

    return (
        <>
            {!subItems.length ? (
                <Link to={path}>
                    <ButtonBase sx={{...commonButtonStyles, ...(active && {backgroundColor: '#1768e3'})}}>
                        {icon && <Box sx={commonIconStyles}>{icon}</Box>}
                        <Box sx={commonBoxStyles}>{title}</Box>
                    </ButtonBase>
                </Link>
            ) : (
                <ButtonBase onClick={toggleExpand}
                            sx={{...commonButtonStyles, ...(active && {backgroundColor: '#1768e3'})}}>
                    {icon && <Box sx={commonIconStyles}>{icon}</Box>}
                    <Box sx={commonBoxStyles}>{title}</Box>
                    {isExpanded ? <KeyboardArrowUpIcon/> : <KeyboardArrowDownIcon/>}
                </ButtonBase>
            )}

            {subItems.length > 0 && isExpanded && (
                <ul style={{listStyleType: 'none', padding: 0, margin: "4px 4px 4px 16px"}}>
                    {subItems.map((subItem, index) => (
                        <li key={subItem.id || index}>
                            <Link to={subItem.path}>
                                <ButtonBase
                                    sx={{...commonButtonStyles, fontWeight: 500}}>
                                    {/*<Box sx={commonIconStyles}>*/}
                                    {/*    <CircleIcon sx={{fontSize: "10px"}}/>*/}
                                    {/*</Box>*/}
                                    {subItem.icon && <Box sx={commonIconStyles}>{subItem.icon}</Box>}
                                    <Box sx={{...commonBoxStyles, fontWeight: 500, fontSize: 11}}>{subItem.title}</Box>
                                </ButtonBase>
                            </Link>
                        </li>
                    ))}
                </ul>
            )}
        </>
    );
};
